export default __webpack_public_path__ + "static/media/astronaut-logo-black.f93c645a.png";